import { getNextApiUrl } from '@/utils/next-api';
import { useUnleash } from '@/unleash';

export const useRegisterLimitations = () => {
  const { data: regLimitations, isReady } = useUnleash('web.reg.limitation');
  const isNewRegActive = regLimitations?.isNewRegActive;

  const loginLink = '/auth';

  const isRegStateV2Active = isReady && regLimitations?.isRegStateV2Active;

  const logoutLink = (query: string = '') => {
    return getNextApiUrl(`auth/logout${query}`);
  };

  const registerLink = isNewRegActive
    ? '/register'
    : getNextApiUrl('auth/register');

  return {
    loginLink,
    isNewRegActive,
    isRegStateV2Active,
    isReady,
    logoutLink,
    registerLink,
  };
};
